import React from "react";
import { Stack, StackProps, TagElement } from "sprint-common-web";

export interface TagElementsListProps<T extends { id: string }> extends Pick<StackProps, "styles"> {
    items: T[];
    vertical?: boolean;
    onItemDismiss(item: T): void;
    renderItemText(item: T): string;
}

export const TagElementsList = <T extends { id: string }>(props: TagElementsListProps<T>): JSX.Element => {
    const renderListText = (item?: T) => {
        if (!item) return "";

        return props.renderItemText(item);
    };

    return (
        <>
            {!!props.items.length && (
                <Stack
                    horizontal={props.vertical ? false : true}
                    tokens={{ childrenGap: 10 }}
                    styles={{ ...props.styles }}
                >
                    {props.items.map((item: T) => {
                        const handleDismiss = () => {
                            props.onItemDismiss(item);
                        };

                        return <TagElement key={item.id} text={renderListText(item)} onDismiss={handleDismiss} />;
                    })}
                </Stack>
            )}
        </>
    );
};
